export class EInvoiceDoc {
    constructor(_id?: number, _longId?: string, _eInvoiceNumber?: string, _licenseId?: number, _businessName?: string, _totalInterest?: number, _issuanceDate?: Date, _formJIds?: number[], _createdOn?: Date, _remark?: string, _submissionUuid?: string, _submittedOn?: Date, _submittedBy?: string, _validationUrl?: string);
    constructor(private _id: number, private _longId: string, private _eInvoiceNumber: string, private _licenseId: number, private _businessName: string, private _totalInterest: number, private _issuanceDate: Date, private _formJIds: number[], private _createdOn?: Date, private _remark?: string, private _submissionUuid?: string, private _submittedOn?: Date, private _submittedBy?: string, private _validationUrl?: string) {}

    get Id(): number { return this._id }
    set Id(value: number) { this._id = value }

    get LongId(): string { return this._longId }
    set LongId(value: string) { this._longId = value }

    get EInvoiceNumber(): string { return this._eInvoiceNumber }
    set EInvoiceNumber(value: string) { this._eInvoiceNumber = value }

    get LicenseId(): number { return this._licenseId }
    set LicenseId(value: number) { this._licenseId = value }

    get BusinessName(): string { return this._businessName }
    set BusinessName(value: string) { this._businessName = value }

    get TotalInterest(): number { return this._totalInterest }
    set TotalInterest(value: number) { this._totalInterest = value }

    get IssuanceDate(): Date { return this._issuanceDate }
    set IssuanceDate(value: Date) { this._issuanceDate = value }

    get FormJIds(): number[] { return this._formJIds }
    set FormJIds(value: number[]) { this._formJIds = value }

    get CreatedOn(): Date { return this._createdOn }
    set CreatedOn(value: Date) { this._createdOn = value }

    get Remark(): string { return this._remark }
    set Remark(value: string) { this._remark = value }

    get SubmissionUuid(): string { return this._submissionUuid }
    set SubmissionUuid(value: string) { this._submissionUuid = value }

    get SubmittedOn(): Date { return this._submittedOn }
    set SubmittedOn(value: Date) { this._submittedOn = value }

    get SubmittedBy(): string { return this._submittedBy }
    set SubmittedBy(value: string) { this._submittedBy = value }

    get ValidationUrl(): string { return this._validationUrl }
    set ValidationUrl(value: string) { this._validationUrl = value }
}

export interface IAPIEInvoice {
    // id: number,
    // licenseId: number,
    issuanceDate: string,
    number: string,
    formJIds?: number[],
    remark: string
}

export const EINVOICE_START_YEAR = 2026 as const;